import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setButtonsCombine } from "../../../store/slices/athleteSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import InfoModal from "../../InfoModal";

export default function AthleteCombineButtons({ profile = {} }) {
  const [showModal, setShowModal] = useState({
    trackit: false,
    position: false,
  });
  const r_athlete = useSelector((state) => state.athletes);
  const dispatch = useDispatch();
  const {
    buttons: {
      combine: { positionTabSelected },
    },
  } = r_athlete;
  const authUser = useAuthUser();

  useEffect(() => {
    dispatch(setButtonsCombine({ athlete: false, position: true }));
  }, [dispatch]);

  return (
    <>
      {!(
        profile.hasCurrentSubscription === false &&
        authUser?.user?.role === "athlete"
      ) ? (
        <div className="flex justify-start items-center my-3">
          {r_athlete.config.showPositionScore && (
            <div className="flex items-center ml-0 cursor-pointer">
              <div
                className={`w-full xl:w-48 lg:w-48 ${
                  positionTabSelected
                    ? "text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-md text-sm px-3 py-2 opacity-100"
                    : "text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-md text-sm px-3 py-2 opacity-50"
                }`}
                onClick={() =>
                  dispatch(
                    setButtonsCombine({ athlete: false, position: true }),
                  )
                }
              >
                <div className="flex justify-between mb-0">
                  <span className="text-sm font-medium text-white">
                    Position Score
                  </span>
                  <span className="text-sm font-medium text-white">
                    {profile.positionScore || 0}
                  </span>
                </div>
                <div className="flex justify-between mb-0">
                  <div className="w-full bg-gray-300 rounded-full h-1 mt-2 mr-4">
                    <div
                      className="bg-white opacity-100 h-1 rounded-full"
                      style={{
                        width: `${Math.min(profile.positionScore || 0, 100)}%`,
                      }}
                    ></div>
                  </div>
                  <div
                    className="ml-2 cursor-pointer text-sm"
                    onClick={() =>
                      setShowModal({ trackit: false, position: true })
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : null}

      <InfoModal
        isOpen={showModal.trackit}
        title="Trackit Score Info"
        description="This score comes from comparing you to every other player that is within your (their) weight range (+ or - 20 lbs) and age regardless of position. Your overall track it score is a combination of your 'track it athletic score' and your 'track it measurement score'. We only compare results that have been verified through one of our combines."
        onClose={() => setShowModal({ trackit: false, position: false })}
      />

      {showModal.position && (
        <InfoModal
          isOpen={showModal.position}
          title="Position Score Info"
          description="This score comes from comparing you to every other player that is in your position group. Age and weight do not play a role in determining this score. Your overall position score is a combination of your 'position athletic score' and your 'position measurement score'. We only compare results that have been verified through one of our combines."
          onClose={() => setShowModal({ trackit: false, position: false })}
        />
      )}
    </>
  );
}
